
import React from "react";
import { format } from "date-fns";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { UpdateLog } from "@/types/admin";

interface LogsTableProps {
  logs: UpdateLog[];
}

const formatValue = (value: string | null): string => {
  if (value === null || value === "null") return "-";
  
  if (value === "true") return "ใช่";
  if (value === "false") return "ไม่ใช่";
  
  if (value === "PENDING") return "รอการตรวจสอบ";
  if (value === "APPROVED") return "อนุมัติแล้ว";
  if (value === "REJECTED") return "ไม่อนุมัติ";
  
  return value;
};

const formatFieldName = (fieldName: string): string => {
  const fieldNameMap: Record<string, string> = {
    "status": "สถานะรายงาน",
    "learning_status": "สถานะการเรียนรู้",
    "submitted_on_time": "ส่งตรงเวลา",
    "class_duration": "ระยะเวลาเรียน",
    "teaching_duration": "ระยะเวลาการสอน",
    "rejection_reason": "เหตุผลที่ไม่อนุมัติ",
  };
  
  return fieldNameMap[fieldName] || fieldName;
};

export const LogsTable: React.FC<LogsTableProps> = ({ logs }) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>วันที่แก้ไข</TableHead>
            <TableHead>ผู้แก้ไข</TableHead>
            <TableHead>เลขที่รายงาน</TableHead>
            <TableHead>ฟิลด์ที่แก้ไข</TableHead>
            <TableHead>จากค่า</TableHead>
            <TableHead>เป็นค่า</TableHead>
            <TableHead>เหตุผล</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {logs.length > 0 ? (
            logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>
                  {format(new Date(log.created_at), "dd/MM/yyyy HH:mm:ss")}
                </TableCell>
                <TableCell>{log.admin_email}</TableCell>
                <TableCell>
                  <a 
                    href={`/reports/${log.report_id}`} 
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    {log.report_id.substring(0, 8)}...
                  </a>
                </TableCell>
                <TableCell>{formatFieldName(log.field_changed)}</TableCell>
                <TableCell>{formatValue(log.old_value)}</TableCell>
                <TableCell>{formatValue(log.new_value)}</TableCell>
                <TableCell>{log.reason}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} className="h-24 text-center">
                ไม่พบข้อมูล
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
